import React from "react";

const EngagementManagementIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44.646"
      height="44.647"
      viewBox="0 0 44.646 44.647"
    >
      <path
        id="db65"
        d="M253.288,257.8h4.143l-.107-1.5c-.214-3.25,2.214-4.251,4.429-1.822l1,1.107,2.893-2.929-1.107-1c-2.393-2.179-1.393-4.608,1.822-4.393l1.5.107v-4.143l-1.5.107c-3.286.25-4.357-2.286-1.857-4.465l1.107-1-2.857-2.857-1,1.143c-2.143,2.465-4.608,1.393-4.465-1.857l.071-1.5h-4.036l.071,1.5c.143,3.25-2.286,4.251-4.393,1.822l-1-1.143-2.964,2.929,1.143,1c2.429,2.107,1.357,4.5-1.822,4.393l-1.5-.071v4.143l1.5-.107c3.215-.215,4.286,2.286,1.893,4.393l-1.178,1L248,255.589l1-1.107c2.143-2.357,4.5-1.393,4.357,1.822Zm2.072-8.072a4.447,4.447,0,1,1,4.465-4.429A4.579,4.579,0,0,1,255.36,249.73Zm-14.144,17c-4.465,0-7.286-2.822-7.286-7.286V231.156c0-4.465,2.822-7.286,7.286-7.286h23.072v3.572c0,5.572,3.465,9,8.965,8.93l3.536-.036v23.109c0,4.465-2.822,7.286-7.286,7.286ZM273.254,232.8a5.358,5.358,0,1,1,5.322-5.358A5.381,5.381,0,0,1,273.254,232.8Z"
        transform="translate(-233.929 -222.084)"
        fill={fill ? fill : "#34fb69"}
      />
    </svg>
  );
};

export default EngagementManagementIcon;
